// Panels the transaction rail opens. The ids are also the rail items' `data-rail-item`, so a panel can
// give the focus back to the item that opened it.
export const RAIL_PANEL = Object.freeze({ RELAYS: 'relays', INFO: 'info', PROTOCOL: 'protocol' });

export const RAIL_PANEL_TITLE = Object.freeze({
    [RAIL_PANEL.RELAYS]: 'Relays',
    [RAIL_PANEL.INFO]: 'Info',
    [RAIL_PANEL.PROTOCOL]: 'Protocol',
});

export const focusRailItem = (transactionId, panel) =>
    document.querySelector(`#transaction-panel-${transactionId} [data-rail-item="${panel}"]`)?.focus();
